import clsx from 'clsx'
import React, { FC, ReactNode } from 'react'
import { Button } from 'react-bootstrap'
import Moment from 'react-moment'
import ButtonLoader from '../ButtonLoader'

interface Props {
    status?: ServiceRequestTimelineStatus
    date?: string | Date
    title: string
    children?: ReactNode
    paymentStatus?: string
    onPrimaryButtonClick?: () => void
    primaryButtonText?: string
    hasPrimaryButton?: boolean
    isPrimaryButtonDisabled?: boolean
    secondaryButtonText?: string
    hasSecondaryButton?: boolean
    isSecondaryButtonLoading?: boolean
    onSecondaryButtonClick?: () => void
    actionButtons?: ReactNode
}

export const enum ServiceRequestTimelineStatus {
    INACTIVE = 'inactive',
    ACTIVE = 'active',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

const TimelineItem: FC<Props> = ({
    status,
    date,
    title,
    children,
    paymentStatus,
    onPrimaryButtonClick,
    primaryButtonText,
    hasPrimaryButton,
    isPrimaryButtonDisabled,
    hasSecondaryButton,
    onSecondaryButtonClick,
    isSecondaryButtonLoading,
    secondaryButtonText,
    actionButtons,
}) => {
    return (
        <div className={clsx([`timeline-item`, status, !children ? 'pb-4' : ''])}>
            <span className={clsx(['beam mb-0', `beam-${status}`])}></span>
            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex flex-column gap-1'>
                    {status === ServiceRequestTimelineStatus.COMPLETED && date ? (
                        <p className='timeline-date mb-0'>
                            <Moment format='ddd Do MMMM YYYY h:mm'>{date}</Moment>
                        </p>
                    ) : null}
                    <p className='fw-bold timeline-title mb-0'>{title}</p>
                    <div className='d-flex flex-column timeline-content'>
                        {(status === ServiceRequestTimelineStatus.ACTIVE ||
                            status === ServiceRequestTimelineStatus.COMPLETED) &&
                        paymentStatus === 'paid' ? (
                            <small className='fw-lighter text-capitalize'>{paymentStatus}</small>
                        ) : null}

                        {children}

                        {actionButtons && <div className='mb-3 d-flex gap-3'>{actionButtons}</div>}

                        {hasPrimaryButton || hasSecondaryButton ? (
                            <div className='mb-3 d-flex gap-3'>
                                {hasPrimaryButton ? (
                                    <Button
                                        disabled={isPrimaryButtonDisabled ?? isSecondaryButtonLoading}
                                        variant='primary'
                                        size='sm'
                                        className=''
                                        onClick={onPrimaryButtonClick}>
                                        {primaryButtonText} {isPrimaryButtonDisabled && <ButtonLoader />}
                                    </Button>
                                ) : null}
                                {hasSecondaryButton ? (
                                    <Button
                                        disabled={isSecondaryButtonLoading ?? isPrimaryButtonDisabled}
                                        variant='outline-primary'
                                        size='sm'
                                        className=''
                                        onClick={onSecondaryButtonClick}>
                                        {secondaryButtonText} {isSecondaryButtonLoading && <ButtonLoader />}
                                    </Button>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimelineItem
